import IssbContainer from "../IssbContainer";
import { Button, Divider, Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
import SourcesListPanel from "../Sources/SourcesListPanel";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import RoundList from "../components/NavItems/RoundList";
import { routes } from "../../../config/paths";
import { useTranslation } from "react-i18next";
import DataInputPage from "../IssbDataInput/DataInputPage";
import useAirUserRoles from "../../../utils/AuthUtils";
import withAuthorization from "../../../context/Auth/WithAuthorization";
import AIDashboard from "../Dashboard/components/AIDashboard/AIDashboard";

const IssbRequirementsPage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const { isOrgAdmin, canAccessEntity } = useAirUserRoles();

  const { t } = useTranslation("translation", {
    keyPrefix: "issb.requirementPage.titles",
  });

  // Support tab navigation and linking: set the tab index from the query param
  const tabIndex = parseInt(searchParams.get("rtab")) || 0; // Default to the first tab
  const [selectedTab, setSelectedTab] = React.useState(tabIndex);
  const setTabIndex = (index) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("rtab", index);
    setSearchParams(newParams);
    setSelectedTab(index);
  };

  useEffect(() => {
    const newTabIndex = parseInt(searchParams.get("rtab")) || 0;
    setSelectedTab(newTabIndex);
  }, [searchParams]);

  const roundSelector = useSelector((state) => state.issbRound);

  const handleStartRound = () => {
    navigate(routes.issbQuestionnaireRoundSetup);
  };

  if (!canAccessEntity()) {
    return (
      <IssbContainer margin="15%">
        <Text>You don't have access to this entity</Text>
      </IssbContainer>
    );
  }

  return (
    <Flex direction="row">
      <IssbContainer margin="15%">
        <Flex direction="column" gap={2}>
          <Text fontSize="heading.3xl" fontWeight="700" color="darkTeal">
            Requirements
          </Text>
          <Text maxW="75%" color="gray.500" fontSize="body.m">
            {t(selectedTab)}
          </Text>
        </Flex>
        <Tabs
          // fontSize="body.s"
          // fontWeight="bold"
          // colorScheme="limeShade"
          variant="primary"
          isLazy={true}
          index={tabIndex}
          onChange={setTabIndex}
        >
          <TabList>
            <Tab>Requirements</Tab>
            <Tab>AI Review</Tab>
            <Tab>Sources</Tab>
          </TabList>

          <Divider />

          {roundSelector?.selectedRound ? (
            <TabPanels>
              <TabPanel px={0}>
                {/*<DataInputPanel />*/}
                <DataInputPage />
              </TabPanel>
              <TabPanel px={0}>
                <AIDashboard />
              </TabPanel>
              <TabPanel px={0}>
                <SourcesListPanel />
              </TabPanel>
            </TabPanels>
          ) : (
            /* no round selected */
            <div>
              <Text color="darkTeal" fontSize="body.m" my={4}>
                Please select a round to get started
              </Text>
              <RoundList variant="secondary" />
              <Divider mt={4} mb={4} />
              {isOrgAdmin && (
                <div>
                  Or{" "}
                  <Button ml={2} variant="secondary" onClick={handleStartRound}>
                    Create a new round
                  </Button>
                </div>
              )}
            </div>
          )}
        </Tabs>
      </IssbContainer>
    </Flex>
  );
};

export default withAuthorization(IssbRequirementsPage);
